import { useBoltApiClient } from "@bolt/core";
import { useMemo } from "react";
import { createBoltCommentsApiClient } from "../lib/apiClients/boltCommentsApiClient";


export const useComments = () => {
  const boltApiClient = useBoltApiClient();

  const commentsApiClient = useMemo(() => {
    return createBoltCommentsApiClient(boltApiClient);
  }, [boltApiClient]);

  return commentsApiClient;
};
